import { Row, Col } from "react-bootstrap";
import { ProductImageURL } from "components/custom/category/listings/ProductImage";

interface Props {
  parentProduct: {
    image_url: string | null;
    title: string;
    parent_asin: string;
  };
}

export function ParentSummaryHeader({ parentProduct }: Props) {
  return (
    <div style={{ display: "flex" }}>
      <div style={{ width: "120px", paddingRight: "20px" }}>
        <ProductImageURL url={parentProduct.image_url} style={{ borderRadius: 15 }} width={100} height={100} />
      </div>
      <div>
        <Row>
          <Col xs={12}>
            <h3
              style={{
                marginBottom: "0.2rem",
                marginTop: "0",
                fontSize: 22,
              }}
            >
              {parentProduct.title}
            </h3>
          </Col>
          <Col xs={12}>{parentProduct.parent_asin}</Col>
          <Col xs={12}></Col>
        </Row>
      </div>
    </div>
  );
}
